<dashboard-dialog-frame [icon]='icon()' [header]='header()' [actions]='actions' [dialogRef]='dialogRef'>

	<div style="display: inline-block; box-sizing: border-box; border: solid 3px orange; padding: .7em .5em;"
		[ngStyle]="{ 'height.px': height(), 'width.px': width() }">

		<h3>Size</h3>

		<pre>
{{ dialog.dimensions() | json }}
		</pre>

	</div>

</dashboard-dialog-frame>